import {z} from "zod"

export const priceSchema = z.object({
  name: z.string().min(3, "Name cannot be empty"),
  price: z.coerce.number().min(0, "Price must be a positive number"),
  uploads: z.coerce.number().min(0, "Uploads must be a positive number"),
  info: z.array(z.string().min(1, "Info cannot be empty")).optional(),
});